import { isWeChat, isAndroid, isiOS } from 'helper/env';
import * as app from '../190506-@shared/modules/service/app';
import * as wx from '../190506-@shared/modules/service/wx';

let service;
if (isAndroid || isiOS) {
  service = app;
} else if (isWeChat) {
  service = wx;
} else if (process.env.NODE_ENV === 'development') {
  service = app;
} else {
  service = wx;
}

export function init() {
  if (process.env.NODE_ENV === 'development') {
    service.mock(
      'f00d%2bQ7suxF%2bGZXy5OfTh6I8INSwejsUFmj9mlmlNN1jLIYb6dS9F1jFQ77%2beNQdOYD10ABE0Nk%3d'
    );
  }

  if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'pre') {
    window.__$service = service;
  }

  return service.init();
}

export default service;
